export default __webpack_public_path__ + "static/media/524021b0-97ee-4d3b-8440-f3408b3eece0.dbeb967a.png";